import React from "react";
import { Box, Button, ButtonGroup } from "@mui/material";
import { ZoomIn, ZoomOut } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const GanttToolbar = ({ onZoomIn, onZoomOut, statusText }) => {
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end",
				gap: 2,
				p: 1,
				borderBottom: "1px solid #e0e0e0",
				backgroundColor: "#fafafa",
			}}
		>
			<ButtonGroup size="medium" variant="outlined">
				<Button
					onClick={onZoomIn}
					startIcon={<ZoomIn />}
					title={t("action.zoomIn")}
				>
					{t("action.zoomIn")}
				</Button>
				<Button
					onClick={onZoomOut}
					startIcon={<ZoomOut />}
					title={t("action.zoomOut")}
				>
					{t("action.zoomOut")}
				</Button>
			</ButtonGroup>

			{statusText && (
				<Box sx={{ fontSize: "0.875rem", color: "#666" }}>{statusText}</Box>
			)}
		</Box>
	);
};

export default GanttToolbar;
